export default async function persistWebview({ next, to, from }) {
  if (!to.query.webview && from.query.webview) {
    next({
      ...to,
      query: {
        ...to.query,
        webview: from.query.webview,
      },
    });
  } else {
    next();
  }
}
